import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './styles/index.css';
import { AppLayout } from './layouts/AppLayout';
import { PageLoader } from './components/PageLoader';
import { registerServiceWorker } from './lib/registerServiceWorker';

const HomePage = lazy(() => import('./pages/HomePage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ComparePage = lazy(() => import('./pages/ComparePage'));
const FaqPage = lazy(() => import('./pages/FaqPage'));
const ScriptsPage = lazy(() => import('./pages/ScriptsPage'));

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      gcTime: 1000 * 60 * 60,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'comparison.html', element: <ComparePage /> },
      { path: 'compare', element: <ComparePage /> },
      { path: 'faq.html', element: <FaqPage /> },
      { path: 'faqs', element: <FaqPage /> },
      { path: 'scripts.html', element: <ScriptsPage /> },
      { path: 'scripts', element: <ScriptsPage /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Suspense fallback={<PageLoader />}>
        <RouterProvider router={router} />
      </Suspense>
    </QueryClientProvider>
  </StrictMode>,
);

registerServiceWorker();
